module.exports = __webpack_public_path__ + "static/media/icon-sheet-2.a9a13771.png";